import { Form, Input } from 'antd'
import React from 'react'

function FormItemInput(props) {
    return (
        <Form.Item
            label={props.label} 
            required={props.required}
            name={props.name}
            style={props.formStyle}
        >
            <Input
                placeholder={props.placeholder}
                onChange={props.onChange}
                onClear={props.onClear}
                style={props.style}
                allowClear
            /> 
        </Form.Item>
    )
}

export default FormItemInput